import { MutationTree } from 'vuex';
import {
  EvaluationsState,
  Evaluation,
} from '@/store/evaluations/types';
import _ from 'lodash';
import { Pager } from '@/store/pager.types';

const mutations: MutationTree<EvaluationsState> = {
  fetchedEvaluations: (state: EvaluationsState, payload: {
    pager: Pager,
    evaluations: Evaluation[]
  }) => {
    state.pager = payload.pager
    state.evaluations = payload.evaluations
  },

  gotEvaluation: (state: EvaluationsState, evaluation: Evaluation) => {
    state.evaluations = _.uniqBy([
      evaluation,
      ...state.evaluations,
    ], 'tutorId')
  },
};

export default mutations;
